import _ from 'lodash';


export const gertCertificates = (state) => _.get(state, 'certificates.list');

export const gertCertificatesMap = (state) => _.get(state, 'certificates.map');
